import styled from 'styled-components'

export const H1 = styled.h1`
  font-weight: bold;
  font-size: 1.5em;
  line-height: 1.5em;
  color: ${({ theme }) => theme.darkGrey}; ;
`
